import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    color_id: data?.color?.id,
    shape_id: data?.shape?.id,
    wrap_id: data?.wrap?.id,
    purchasable: data?.purchasable,
    track_inventory: data?.track_inventory,
    show_in_packaging: data?.show_in_packaging ?? false,
    is_active: data?.is_active ?? true,
    display_priority: data?.display_priority ?? "",
  };
};

export const structure = (options, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_wrap_variants.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.write_name_en")
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_wrap_variants.name_ar"),
        width: "47%",
        placeholder: t("wrappers_wrap_variants.write_name_ar")
      },
      {
        name: `wrap_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_wrap_variants.wrap")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.choose_wrap"),
        ...options?.wraps
      },
      {
        name: `color_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_wrap_variants.color")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.choose_color"),
        ...options?.colors
      },
      {
        name: `shape_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_wrap_variants.shape")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.choose_shape"),
        ...options?.shapes
      },
      {
        name: `count_on_hand`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_variants.quantity")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.write_quantity")
      },
      {
        name: `price`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_variants.price")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.write_price"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >SAR</p>
        )
      },
      {
        name: `price_after_discount`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_wrap_variants.price_after_discount")}*`,
        width: "47%",
        placeholder: t("wrappers_wrap_variants.write_price"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >SAR</p>
        )
      },
      {
        name: `purchasable`,
        kind: "checkbox",
        label: t("wrappers_wrap_variants.purchasable"),
        width: "fit-content",
      },
      {
        name: `track_inventory`,
        kind: "checkbox",
        label: t("wrappers_wrap_variants.track_inventory"),
        width: "fit-content",
      },
      {
        name: `show_in_packaging`,
        kind: "checkbox",
        label: t("wrappers_wrap_variants.show_in_packaging"),
        width: "fit-content",
      },
      {
        name: `is_active`,
        kind: "checkbox",
        label: t("wrappers_wrap_variants.is_active"),
        width: "fit-content",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("wrappers_wrap_variants.display_priority"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = (wrapId) =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required('Required'),
    }),
    price: Yup.number().required("required"),
    price_after_discount: Yup.number().required("required"),
    count_on_hand: Yup.number().required("required"),
    // // shape_id: Yup.number().required("required"),
    // // wrap_id: Yup.number().required("required"),
    color_id: Yup.number().required("required"),
    wrap_id: Yup.number().required("required"),
    shape_id: Yup.number().required("required"),
    show_in_packaging: Yup.boolean(),
    is_active: Yup.boolean(),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  },
  );